import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";

const Container = styled.div`
  display: flex;
  margin: 15px 0;
  justify-content: center;
  height: 372px;
  width: 100%;
  @media (max-width: 1024px) {
    position: relative;
    justify-content: flex-start;
  }
  @media (max-width: 440px) {
    flex-direction: column;
    height: auto;
  }
`;
const TextContainer = styled.div`
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  max-width: 547px;
  width: 100%;
  justify-content: center;
  @media (max-width: 1024px) {
    position: absolute;
    z-index: 5;
    background-color: rgb(247 247 247 / 85%);
    padding: 20px;
    justify-content: center;
    height: 300px;
    max-width: 680px;
    bottom: 25px;
    left: 25px;
  }
  @media (max-width: 770px) {
    height: 200px;
    max-width: 547px;
  }
  @media (max-width: 440px) {
    position: relative;
    left: 0;
    bottom: 0;
    height: auto;
    background-color: transparent;
    padding-left: 0;
  }
`;
const Img = styled(ImageLibpixel)`
  width: 100%;
  object-fit: cover;
  max-width: 807px;
  height: 372px;
  @media (max-width: 1024px) {
    max-width: unset;
    position: absolute;
    top: 0;
    left: 0;
  }
  @media (max-width: 770px) {
    max-width: 770px;
  }
  @media (max-width: 440px) {
    position: relative;
    height: 200px;
  }
`;
const Title = styled.h1`
  font-size: 2rem;
  margin-top: 0;
  font-weight: 400;
  color: #1b2636;
  @media (max-width: 440px) {
    font-size: 1.5rem;
  }
`;
const Description = styled.div`
  font-size: 1.1rem;
  line-height: 1.5;
  @media (max-width: 1030px) {
    margin-bottom: 0;
  }
  @media (max-width: 770px) {
    height: 120px;
    overflow: hidden;
  }
  @media (max-width: 440px) {
    font-size: 0.9rem;
    height: auto;
    overflow: visible;
  }
`;

const SectionTop = ({ imgUrl, title, content }) => {
  return (
    <Container itemScope itemType="http://schema.org/Blog">
      <Img itemProp="image" alt={_("post")} src={imgUrl} />
      <TextContainer>
        <Title itemProp="name">
          {title &&
            title
              .replace("&#038;", "&")
              .replace("&amp;", "&")
              .replace("&#8211;", "-")}
        </Title>
        <Description
          dangerouslySetInnerHTML={{ __html: content }}
        ></Description>
      </TextContainer>
    </Container>
  );
};

SectionTop.propTypes = {
  imgUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

SectionTop.defaultProps = {
  imgUrl: "",
};

export default SectionTop;
